module.exports = __webpack_public_path__ + "media/hero_1.9c0bcc4d.mp4";